var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#5F5FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.666 4.66602H9.33268C5.33268 4.66602 2.66602 6.66602 2.66602 11.3327V20.666C2.66602 25.3327 5.33268 27.3327 9.33268 27.3327H22.666C26.666 27.3327 29.3327 25.3327 29.3327 20.666V11.3327C29.3327 6.66602 26.666 4.66602 22.666 4.66602ZM23.2927 12.786L19.1193 16.1193C18.2393 16.826 17.1193 17.1727 15.9993 17.1727C14.8793 17.1727 13.746 16.826 12.8793 16.1193L8.70602 12.786C8.27935 12.4393 8.21268 11.7993 8.54602 11.3727C8.89268 10.946 9.51935 10.866 9.94602 11.2127L14.1193 14.546C15.1327 15.3593 16.8527 15.3593 17.866 14.546L22.0393 11.2127C22.466 10.866 23.106 10.9327 23.4393 11.3727C23.786 11.7993 23.7193 12.4393 23.2927 12.786Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.b09be3546443b1936b3d6c56a55e57bb.svg";
export { ForwardRef as ReactComponent };